
/**
* cardsList.directives Module
*
* Description
*/
var app = angular.module('directives.metallist', []);

	require('./directives/metallist.directive.js');
	require('./stylesheet/style.scss');

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/metallist/index.js
 ** module id = 185
 ** module chunks = 1
 **/